<template>
  <model>
    <div class="wrapper">
      <div class="title"></div>
      <div class="content my-scroll" v-html="content"></div>
      <transition
        mode="out-in"
        enter-active-class="fadeIn animated faster"
        leave-active-class="fadeOut animated faster"
      >
        <div class="btn close" @click="exit" v-if="desSecond <= 0 || isTick" key="btn-close"></div>
        <span class="des" v-else key="second">离打卡成功还需{{ desSecond }}秒</span>
      </transition>
    </div>
  </model>
</template>

<script>
import { clearStyle } from '@js/util';

let stiId = 0;
export default {
  name: 'detail',
  data() {
    return {
      content: '',
      second: 0,
      once: true,
    };
  },
  computed: {
    desSecond() {
      const des = this.$activity.secondMin - this.second;
      return des > 0 ? des : 0;
    },
    isTick() {
      return this.$parent.visited.includes(this.$route.params.id);
    },
  },
  methods: {
    exit() {
      // console.log(this.$parent);
      if (!this.once) return;
      this.once = false;
      window.clearInterval(stiId);
      if (this.isTick) {
        this.$router.go(-1);
        return;
      }
      if (this.second >= this.$activity.secondMin) {
        this.$parent.recordEx(this.$route.params.id);
      } else {
        this.$parent.tickFail();
      }
      this.$router.go(-1);
    },
  },
  mounted() {
    stiId = setInterval(() => {
      this.second += 1;
    }, 1000);
  },
  created() {
    this.$loading.show('正在加载介绍');
    this.$axios
      .get(this.$route.params.link)
      .then((res) => {
        console.log(res);
        // console.log(typeof res.data);
        let content;
        if (typeof res.data === 'string') {
          const parser = new DOMParser();
          const doc = parser.parseFromString(res.data, 'text/html');
          content = doc;
        } else {
          content = res.data;
        }
        this.title = content.querySelector('.art-title').innerHTML;
        content.querySelector('.art-title').remove();
        this.content = clearStyle(content).querySelector('#art-content').innerHTML;
        // console.log(this.contentCleared);
      })
      .catch((err) => console.log(err))
      .finally(() => {
        this.$loading.hide();
      });
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  position: absolute;
  @include w(669);
  @include center(669);
  @include h(961);
  @include bg("intro.png");
  top: 4vh;
  z-index: 11;
}

.title {
  @include w(338);
  @include h(78);
  @include bg("exhibition-intro-title.png");
  margin: auto;
  margin-top: px2rem(80);
  margin-bottom: px2rem(25);
}

.content {
  @include w(505);
  @include h(700);
  margin: auto;
  color: white;
  line-height: 1.3em;
  font-size: 0.6rem;
}

.btn.close {
  position: absolute;
  @include w(60);
  @include center(60);
  @include h(60);
  @include bg("btn-close.png");
  bottom: -2rem;
}

.des {
  width: 10em;
  display: block;
  font-size: 0.5rem;
  bottom: -1.8rem;
  position: absolute;
  left: 50%;
  margin-left: -5em;
  line-height: 2em;
  background-color: white;
  border: 0;
  border-radius: 1em;
  text-align: center;
  color: #094ed0;
}
</style>
